import { ReactElement, ReactNode, UIEvent, useState } from 'react'

import { StickyColumnTableProps, TableColumn } from './types'

import { EmptyCell, ScrollWrapper, Table, Td, Th } from './styles'

export { MediaCoverCell, type MediaCoverCellProps } from './MediaCoverCell'
export type { StickyColumnTableProps, TableColumn }

export const StickyColumnTable = <T,>({
  columns,
  data,
  rowKey,
  emptyState,
  className,
}: StickyColumnTableProps<T>): ReactElement => {
  const [isScrolled, setIsScrolled] = useState(false)

  const handleScroll = (event: UIEvent<HTMLDivElement>): void => {
    const scrolled = event.currentTarget.scrollLeft > 0
    setIsScrolled((prev) => (prev === scrolled ? prev : scrolled))
  }

  const isEmpty = data.length === 0

  return (
    <ScrollWrapper className={className} onScroll={handleScroll}>
      <Table>
        <thead>
          <tr>
            {columns.map((column) => (
              <Th
                key={column.key}
                $align={column.align}
                $width={column.width}
                $fixed={column.fixed === 'left'}
                $scrolled={isScrolled}
              >
                {column.title}
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isEmpty
            ? emptyState && (
                <tr>
                  <EmptyCell colSpan={columns.length}>{emptyState}</EmptyCell>
                </tr>
              )
            : data.map((row) => (
                <tr key={rowKey(row)}>
                  {columns.map((column) => (
                    <Td
                      key={column.key}
                      $align={column.align}
                      $width={column.width}
                      $fixed={column.fixed === 'left'}
                      $scrolled={isScrolled}
                    >
                      {column.render
                        ? column.render(row)
                        : (row as Record<string, ReactNode>)[column.key]}
                    </Td>
                  ))}
                </tr>
              ))}
        </tbody>
      </Table>
    </ScrollWrapper>
  )
}
